<div class="grid grid-cols-1 lg:grid-cols-[80px_calc(100svw-80px)]">
  <nutrix-sidebar class="z-10">
    <!-- logo nutrix -->
    <div
      class="text-gray-700 border-gray-700 focus:ring-2 focus:outline-hidden focus:ring-nutrix rounded-lg font-medium text-sm p-1 text-center inline-flex items-center hover:cursor-default"
    >
      <span class="text-3xl">g</span>
      <span class="text-3xl text-nutrix">+</span>
    </div>
    <div class="h-px w-full bg-gray-200"></div>
    <!-- users -->
    @if (isAdmin()) {
      <div class="flex items-center gap-3 w-full lg:w-auto">
        <p-button
          pTooltip="Usuarios"
          tooltipPosition="right"
          routerLink="users"
          routerLinkActive
          #rlaUsers="routerLinkActive"
          [outlined]="!rlaUsers.isActive"
          [text]="!rlaUsers.isActive"
          [severity]="!rlaUsers.isActive ? 'secondary' : 'primary'"
          icon="pi pi-user-edit"
          size="large"
        />
        <span class="text-sm font-medium text-gray-700 lg:hidden">Usuarios</span>
      </div>
    }
    <!-- HR -->
    @if (isHr()) {
      <div class="flex items-center gap-3 w-full lg:w-auto">
        <p-button
          pTooltip="Recursos Humanos"
          tooltipPosition="right"
          routerLink="hr"
          routerLinkActive
          #rlaHr="routerLinkActive"
          [outlined]="!rlaHr.isActive"
          [text]="!rlaHr.isActive"
          [severity]="!rlaHr.isActive ? 'secondary' : 'primary'"
          icon="pi pi-building"
          size="large"
        />
        <span class="text-sm font-medium text-gray-700 lg:hidden">Recursos Humanos</span>
      </div>
    }
    <!-- laboratory -->
    @if (isLaboratory()) {
      <div class="flex items-center gap-3 w-full lg:w-auto">
        <p-button
          pTooltip="Laboratorio"
          tooltipPosition="right"
          routerLink="laboratory"
          routerLinkActive
          #rlaLaboratory="routerLinkActive"
          [outlined]="!rlaLaboratory.isActive"
          [text]="!rlaLaboratory.isActive"
          [severity]="!rlaLaboratory.isActive ? 'secondary' : 'primary'"
          icon="pi pi-qrcode"
          size="large"
        />
        <span class="text-sm font-medium text-gray-700 lg:hidden">Laboratorio</span>
      </div>
    }
    <!-- laboratory availability / cupos -->
    @if (isLaboratory()) {
      <div class="flex items-center gap-3 w-full lg:w-auto">
        <p-button
          pTooltip="Cupos de laboratorio"
          tooltipPosition="right"
          routerLink="lab-availability"
          routerLinkActive
          #rlaLabAvailability="routerLinkActive"
          [outlined]="!rlaLabAvailability.isActive"
          [text]="!rlaLabAvailability.isActive"
          [severity]="!rlaLabAvailability.isActive ? 'secondary' : 'primary'"
          icon="pi pi-inbox"
          size="large"
        />
        <span class="text-sm font-medium text-gray-700 lg:hidden">Cupos de laboratorio</span>
      </div>
    }
    <!-- agenda -->
    @if (canAccessAgenda()) {
      <div class="flex items-center gap-3 w-full lg:w-auto">
        <p-button
          pTooltip="Agenda"
          tooltipPosition="right"
          routerLink="agenda"
          routerLinkActive
          #rlaAgenda="routerLinkActive"
          [outlined]="!rlaAgenda.isActive"
          [text]="!rlaAgenda.isActive"
          [severity]="!rlaAgenda.isActive ? 'secondary' : 'primary'"
          icon="pi pi-calendar"
          size="large"
        />
        <span class="text-sm font-medium text-gray-700 lg:hidden">Agenda</span>
      </div>
    }
    <!-- patients -->
    <div class="flex items-center gap-3 w-full lg:w-auto" nutrixAccessLevel="journey">
      <p-button
        pTooltip="Pacientes"
        tooltipPosition="right"
        routerLink="patients"
        routerLinkActive
        #rlaPatients="routerLinkActive"
        [outlined]="!rlaPatients.isActive"
        [text]="!rlaPatients.isActive"
        [severity]="!rlaPatients.isActive ? 'secondary' : 'primary'"
        icon="pi pi-users"
        size="large"
      />
      <span class="text-sm font-medium text-gray-700 lg:hidden">Pacientes</span>
    </div>
    <!-- case management -->
    @if (hasCaseManagerAccess()) {
      <div class="flex items-center gap-3 w-full lg:w-auto">
        <p-button
          pTooltip="Gestor de casos"
          tooltipPosition="right"
          routerLink="case-manager"
          routerLinkActive
          #rlaCaseManager="routerLinkActive"
          [outlined]="!rlaCaseManager.isActive"
          [text]="!rlaCaseManager.isActive"
          [severity]="!rlaCaseManager.isActive ? 'secondary' : 'primary'"
          size="large"
          icon="pi"
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3h-4Z"
            />
          </svg>
        </p-button>
        <span class="text-sm font-medium text-gray-700 lg:hidden">Gestor de casos</span>
      </div>
    }
    <!-- chats -->
    <div class="flex items-center gap-3 w-full lg:w-auto" nutrixAccessLevel="chat">
      <p-overlaybadge severity="danger" badgeSize="small" [badgeDisabled]="(hasUnreadMessages$ | async) === false">
        <p-button
          pTooltip="Chats"
          tooltipPosition="right"
          routerLink="chats"
          routerLinkActive
          #rlaChats="routerLinkActive"
          [outlined]="!rlaChats.isActive"
          [text]="!rlaChats.isActive"
          [severity]="!rlaChats.isActive ? 'secondary' : 'primary'"
          icon="pi pi-comment"
          size="large"
        />
      </p-overlaybadge>
      <span class="text-sm font-medium text-gray-700 lg:hidden">Chats</span>
    </div>
    <!-- support chat -->
    <div class="flex items-center gap-3 w-full lg:w-auto">
      <p-button
        pTooltip="Chat de soporte"
        tooltipPosition="right"
        routerLink="support"
        routerLinkActive
        #rlaSupport="routerLinkActive"
        [outlined]="!rlaSupport.isActive"
        [text]="!rlaSupport.isActive"
        [severity]="!rlaSupport.isActive ? 'secondary' : 'primary'"
        size="large"
        icon="pi"
      >
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.8"
            d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2"
          />
        </svg>
      </p-button>
      <span class="text-sm font-medium text-gray-700 lg:hidden">Chat de soporte</span>
    </div>
    <nutrix-ui-dropdown>
      <div class="px-4 py-3 text-sm text-gray-900">
        <div>{{ user()?.name }}</div>
        <div class="font-medium truncate">{{ user()?.contact?.primaryEmailAddress }}</div>
      </div>
      <ul class="py-2 text-sm text-gray-700" aria-labelledby="dropdownUserAvatarButton">
        <li>
          <a
            [tabIndex]="0"
            routerLink="profile"
            class="block px-4 py-2 hover:bg-gray-100 cursor-pointer focus:ring-2 focus:ring-gray-700 focus:rounded-md"
            >Configuración</a
          >
        </li>
      </ul>
      <div class="py-2">
        <a
          role="button"
          tabindex="0"
          (click)="logout()"
          (keydown.enter)="logout()"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer focus:ring-2 focus:ring-gray-700 focus:rounded-md"
          >Cerrar sesión</a
        >
      </div>
    </nutrix-ui-dropdown>
  </nutrix-sidebar>
  <div class="m-0 z-0 h-svh">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- WhatsApp calling: global widget + incoming-call overlay, persist across navigation -->
<nutrix-call-widget />
<nutrix-incoming-call />
